import { render, staticRenderFns } from "./SlideCustomer.vue?vue&type=template&id=14ce7ae4&scoped=true&"
import script from "./SlideCustomer.vue?vue&type=script&lang=js&"
export * from "./SlideCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ce7ae4",
  null
  
)

export default component.exports